
import jqueryUrl from '../assets/js/jquery.min.js?url';
import bootstrapUrl from '../assets/js/bootstrap.min.js?url';

export const loadScripts = () => {
  return new Promise((resolve, reject) => {
    if (window.jQuery) {
      loadBootstrap().then(resolve).catch(reject);
      return;
    }

    const jqueryScript = document.createElement('script');
    jqueryScript.src = jqueryUrl;
    jqueryScript.onload = () => {
      window.$ = window.jQuery;
      loadBootstrap().then(resolve).catch(reject);
    };
    jqueryScript.onerror = () => reject(new Error('Failed to load jQuery'));
    document.head.appendChild(jqueryScript);
  });
};

const loadBootstrap = () => {
  return new Promise((resolve, reject) => {
    if (window.bootstrap) {
      resolve();
      return;
    }

    const bootstrapScript = document.createElement('script');
    bootstrapScript.src = bootstrapUrl;
    bootstrapScript.onload = () => resolve();
    bootstrapScript.onerror = () => reject(new Error('Failed to load Bootstrap'));
    document.head.appendChild(bootstrapScript);
  });
};

